import API from '.';

export default class Country {
  /**
   * The Country dimension table for UDM
   * @param {number} countryId Id of the country.
   * @param {string} countryName Name of the country.
   * @param {string} countryCode Code of the country.
   */
  constructor({ countryId, countryName, countryCode }) {
    this.countryId = countryId;
    this.countryName = countryName;
    this.countryCode = countryCode;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/country');
    return data.map((d) => new Country(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`country/${id}`);
    return new Country(data);
  }
}
